import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../Accordion/Accordion';
import AccordionItem from '../Accordion/AccordionItem';
import { useHistory } from 'react-router-dom';
import useMode from '../../hooks/useMode';
import Address from '../Address/Address';
import { Company } from './CompanyThirdPane.queries';

type CompanyDetailProps = {
  company: Company;
};

const CompanyDetail: React.FC<CompanyDetailProps> = ({ company }) => {
  const history = useHistory();
  const mode = useMode();

  return (
    <>
      <Accordion title="Contact">
        <AccordionItem label="Name" value={company.name} />
        {company.phones.map((phone, idx) => (
          <AccordionItem
            key={`${phone.id}-${idx}`}
            label={
              phone.subType === 'UNKNOWN' ? `Phone` : `Phone (${phone.subType})`
            }
            value={phone.value}
          />
        ))}
        {company.emails.map((email, idx) => (
          <AccordionItem
            key={`${email.id}-${idx}`}
            label={
              email.subType === 'UNKNOWN' ? `Email` : `Email (${email.subType})`
            }
            value={email.value}
          />
        ))}
        {company.contactAddress && (
          <AccordionItem
            label="Mailing Address"
            value={<Address address={company.contactAddress} />}
          />
        )}
      </Accordion>
    </>
  );
};

CompanyDetail.propTypes = {
  company: PropTypes.any,
};

export default CompanyDetail;
